import type { Notiz } from './api'

export interface Tag {
  /** ISO-Datum des Tages, z. B. 2026-09-26 */
  datum: string
  titel: string
  notizen: Notiz[]
}

/** Kalendertag eines Zeitpunkts in einer Zeitzone als YYYY-MM-DD */
export function tagesDatum(zeitpunkt: Date, zeitzone: string): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: zeitzone, year: 'numeric', month: '2-digit', day: '2-digit' }).format(zeitpunkt)
}

function tagDavor(datum: string): string {
  const d = new Date(`${datum}T12:00:00Z`)
  d.setUTCDate(d.getUTCDate() - 1)
  return d.toISOString().substring(0, 10)
}

export function tagesTitel(datum: string, heute: string): string {
  if (datum === heute) return 'Heute'
  if (datum === tagDavor(heute)) return 'Gestern'
  const d = new Date(`${datum}T12:00:00Z`)
  return new Intl.DateTimeFormat('de-DE', {
    timeZone: 'UTC',
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    ...(datum.substring(0, 4) !== heute.substring(0, 4) && { year: 'numeric' }),
  }).format(d)
}

/**
 * Gruppiert Notizen (neueste zuerst) nach Kalendertag. Massgeblich ist die Zeitzone, in der die Notiz
 * aufgenommen wurde: Eine Notiz von 23:30 Uhr in Lissabon gehoert zu dem Tag, den man dort erlebt hat.
 */
export function nachTagen(notizen: Notiz[], jetzt: Date, eigeneZeitzone: string): Tag[] {
  const heute = tagesDatum(jetzt, eigeneZeitzone)
  const tage = new Map<string, Notiz[]>()
  for (const n of notizen) {
    const datum = tagesDatum(new Date(n.aufgenommenAm), n.zeitzone)
    tage.set(datum, [...(tage.get(datum) ?? []), n])
  }
  return [...tage.entries()]
    .sort(([a], [b]) => b.localeCompare(a))
    .map(([datum, liste]) => ({
      datum,
      titel: tagesTitel(datum, heute),
      notizen: liste.sort((a, b) => b.aufgenommenAm.localeCompare(a.aufgenommenAm)),
    }))
}

export function uhrzeit(n: Pick<Notiz, 'aufgenommenAm' | 'zeitzone'>): string {
  return new Intl.DateTimeFormat('de-DE', { timeZone: n.zeitzone, hour: '2-digit', minute: '2-digit' }).format(new Date(n.aufgenommenAm))
}

export function dauer(ms: number): string {
  const s = Math.floor(ms / 1000)
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`
}
